"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateInputFieldComponent = void 0;
const react_1 = __importDefault(require("react"));
const FieldRender_1 = __importDefault(require("../wrappers/FieldRender"));
const RepeatableRender_1 = __importDefault(require("../wrappers/RepeatableRender"));
const ValidationOptimizer_1 = __importDefault(require("../wrappers/ValidationOptimizer"));
const ComputedOptimizer_1 = __importDefault(require("../wrappers/ComputedOptimizer"));
const PageContexts_1 = require("../Contexts/PageContexts");
const lodash_1 = __importDefault(require("lodash"));
/**
 * This is a helper function to create the most typical type of Page component, one that supports conditional display,
 * repeatable fields, field level validation, and read only support
 * @param controlProvider The map of controls from which to grab the consumer's implementation
 * @param componentType the form component type name that we are building
 */
const generateInputFieldComponent = (controlProvider, componentType) => {
    const NewComponent = (props) => {
        const Control = controlProvider[componentType];
        const { setPageState } = (0, PageContexts_1.usePageState)();
        const { controlDefinition, controlPath, value, values, displayMap, forceOneLine, hidden } = props;
        if (Control) {
            return (react_1.default.createElement(ComputedOptimizer_1.default, { controlDefinition: controlDefinition, controlPath: controlPath },
                react_1.default.createElement(RepeatableRender_1.default, { controlPath: controlPath, controlDefinition: controlDefinition, value: value, values: values, renderControl: repeatableProps => {
                        return (react_1.default.createElement(ValidationOptimizer_1.default, { key: repeatableProps.key, controlDefinition: controlDefinition, displayMap: displayMap, render: validationFn => {
                                return (react_1.default.createElement(FieldRender_1.default, { controlPath: (repeatableProps && repeatableProps.controlPath) || controlPath, controlDefinition: controlDefinition, validationFn: validationFn, value: repeatableProps.value, values: values, defaultDateTimeFormat: props.defaultDateTimeFormat, render: props => {
                                        var _a;
                                        return ((_a = props.displayOptions) === null || _a === void 0 ? void 0 : _a.isVisible) !== false && !hidden ? (react_1.default.createElement(Control, Object.assign({}, Object.assign(Object.assign(Object.assign({}, repeatableProps), props), { onChange: (val) => setPageState((prev) => lodash_1.default.set(lodash_1.default.cloneDeep(prev), controlPath, val)), controlDefinition: Object.assign(Object.assign({}, controlDefinition), { oneLine: forceOneLine || controlDefinition.oneLine, truncate: forceOneLine, label: props.label || controlDefinition.label }) })))) : react_1.default.createElement(react_1.default.Fragment, null);
                                    } }));
                            } }));
                    } })));
        }
        else {
            return null;
        }
    };
    NewComponent.displayName = `ConditionalRepeatableValidatedField => ${componentType}`;
    return NewComponent;
};
exports.generateInputFieldComponent = generateInputFieldComponent;
